// extracted by mini-css-extract-plugin
module.exports = {"copy-icon":"CopyToClipBoard_copy-icon__2eATZ"};